import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectIsLoading } from "redux-toolkit/predictors/selectors";
import { updatePredictorAsync } from "redux-toolkit/predictors/actions";

const usePredictorVotes = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);

  const handleVote = useCallback(
    (id, currentUserId, state) => {
      const data = {
        [`votes.${currentUserId}`]: state,
      };
      dispatch(
        updatePredictorAsync({
          id,
          data,
        }),
      );
    },
    [dispatch],
  );

  return {
    isLoading,
    handleVote,
  };
};

export default usePredictorVotes;
